
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

// Utility: Upload Files to Firebase Storage
export const uploadFilesToFirebase = async (files) => {
    const storage = getStorage();
    const uploadPromises = files.map(async (file) => {
        const uniqueFileName = `${uuidv4()}-${file.name}`;
        const storageRef = ref(storage, `all_imges/${uniqueFileName}`);
        const snapshot = await uploadBytes(storageRef, file.originFileObj);
        return getDownloadURL(snapshot.ref);
    });
    return await Promise.all(uploadPromises);
};